<template>
    <div class="text-xs text-gray-500 mb-1">{{ text }}</div>
</template>

<script>
export default {
    props: {
      text: {
        type: String,
        default: 'Label Padrão'
      }
    }
}

</script>